import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';
import UserStore from '../stores/UserStore';
import PromoCode from '../records/PromoCode';
import JourneyPlanService from '../services/JourneyPlanService';
import t from '../lib/I18n';

const PromoCodeActions = {

    async apply (promoCode) {
        AppDispatcher.dispatch({
            promoCode,
            actionType: ActionTypes.PROMOCODE_APPLIED
        });
    },

    async validatePromoCode (promoCode) {
        const user = UserStore.getCurrent();
        const promoProps = {};

        if (promoCode.length > 20) {
            promoProps.validationError = t('booking.promoCode.char.limit.error');
            return new PromoCode(promoProps);
        }

        try {
            const { result, errors } = await JourneyPlanService.validatePromoCode(user.id, promoCode);

            if (errors) {
                promoProps.validationError = errors[0].message;
            }

            if (result) {
                promoProps.promoCode = result.promoCode;
                promoProps.terms = result.limitationsCopy;
            }
        } catch (e) {
            promoProps.validationError = t('booking.promoCode.generic.error');
        }

        return new PromoCode(promoProps);
    },

};

export default PromoCodeActions;



// WEBPACK FOOTER //
// ./src/actions/PromoCodeActions.js